var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewTribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "266.000000pt",
    height: "31.000000pt",
    viewBox: "0 0 266.000000 31.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,31.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166 164 c-92 -69 -166 -131 -163 -137 2 -7 17 -13 33 -15 24 -2 56 19 172 109 134 104 144 110 161 95 10 -9 23 -16 30 -16 13 0 46 29 40 34 -55 41 -79 56 -91 56 -8 0 -90 -57 -182 -126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488 283 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 175 c-19 -15 -19 -15 5 -35 24 -20 67 -28 56 -10 -9 14 8 12 25 -2 8 -7 -1 4 -19 25 -40 42 -40 42 -67 22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTribe);
export default __webpack_public_path__ + "static/media/newTribe.560e4baafa582dc0c5892573cca0a1a9.svg";
export { ForwardRef as ReactComponent };